export type ChatType = 'event' | 'group' | 'smatcher';
export type ChatStatus = 'active' | 'muted' | 'bloqued' | 'ended';

export const CreateChannel = 'createChannel';
export const JoinChannel = 'joinChannel';
export const ChannelJoined = 'ChannelJoined';
export const ChannelCreated = 'channelCreated';
export const SendMessage = 'send-message';
export const LeaveChannel = 'leave-channel';
export const MessageSent = 'message-sent';

export const MessageSentTo = (chatId: string) => `${MessageSent}-${chatId}`;

export type ChatMessageDataImage = { url: string };
export type ChatMessageDataDocument = { link: string; size?: number };
export type ChatMessageDataText = { text: string };
/**
 * One of the sender's outings, as a card (« Ton mélange », 31/10/2026). The
 * phone sends the id alone; the API checks the outing and adds its title as
 * it was, for the conversation list and the notification. The card reads the
 * outing again, so it is always up to date. `text` is never there, and is
 * declared so that reading it off any message stays allowed.
 */
export type ChatMessageDataOuting = { eventId: string; title?: string; text?: undefined };

// export type ChatMessageData = ChatMessageDataText | ChatMessageDataImage | ChatMessageDataDocument;
export type ChatMessageData = ChatMessageDataText | ChatMessageDataOuting;
export type ChatMessageType = 'text' | 'image' | 'document' | 'voice' | 'video' | 'outing';

export interface CreateNewMessage {
  chatId: string;
  type: ChatType;
  messageType: ChatMessageType;
  messageData: ChatMessageData;
  /** The message this one answers, in the same conversation. */
  replyToId?: string;
}

/**
 * The message a reply answers, read from the original at each load: its
 * words are empty once removed with its author's account.
 */
export interface QuotedMessage {
  _id: string;
  sentBy: string;
  displayName: string;
  messageType: string;
  text: string;
  removed: boolean;
}

export interface NewMessageSent {
  _id: string;
  messageType: ChatMessageType;
  time: string;
  chatId: string;
  sentBy: string;
  messageData: ChatMessageData;
  displayName: string;
  avatarUrl?: string;
  readByUserIds: string[];
  replyToId?: string;
  replyTo?: QuotedMessage;
}
